module.exports = __webpack_public_path__ + "fonts/Gilroy-400.1e09f38.otf";